module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/pagination/pagination.component.scss
// module id = ./src/app/shared/pagination/pagination.component.scss
// module chunks = main